module.exports = __webpack_public_path__ + "static/toboriImg2-26d88655a4050706b755bcddf57ac025.jpg";